module.exports = __webpack_public_path__ + "img/close.0f71bd3c.svg";